/* eslint-disable camelcase */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
const DEFAULT_QUICK_AMOUNTS = [100, 1000, 10000, 100000]
/** get_base_data 接口 data 默认空结构 */
const emptyBaseData = () => ({
  err_msg: '',
  activity_id: 0,
  rank_id: 0,
  bet_quick_amounts: [], // 快捷下注金额
  selected_date: '', // 当前选中日期
  selected_match_id: 0, // 当前选中场次
  ticket_count: 0, // 用户剩余竞猜币
  user_coin: 0, // 用户剩余金币
  is_activity_open: false, // 活动是否开启
  schedule_list: [], // 按日期分组的赛程
})

/** 拉取活动页基础数据（赛程、余额、快捷金额等） */
export const get_base_data = createAsyncThunk(
  'WorldCupGuess/get_base_data',
  async (_, {getState}: any) => {
    const {selected_date} = getState().WorldCupGuess
    const resp = await http.post(
      '/activity/api/world_cup_guessing/v1/get_base_data',
      {
        ...getState().env.deviceinfo,
        ...(selected_date ? {selected_date} : {}),
      }
    )
    return resp.data
  }
)

const initialState = {
  ...emptyBaseData(),
  /** 是否已完成首次 base_data 拉取（仅首次采用接口返回的选中日期/场次） */
  baseDataLoaded: false,
}

export const WorldCupGuessSlice = createSlice({
  name: 'WorldCupGuess',
  initialState,
  reducers: {
    /** 切换日期 tab，并默认选中该日第一场 */
    setScheduleDate: (state, action) => {
      state.selected_date = action.payload
      const day = state.schedule_list.find(
        item => item.schedule_date === action.payload
      )
      const firstMatch = day?.schedule_list?.[0]
      if (firstMatch) {
        state.selected_match_id = firstMatch.match_id
      }
    },
    setSelectedMatchId: (state, action) => {
      state.selected_match_id = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(get_base_data.fulfilled, (state, action) => {
      const data = (action.payload as any)?.data ?? action.payload
      const isFirstLoad = !state.baseDataLoaded
      const {selected_date, selected_match_id} = state
      Object.assign(state, emptyBaseData(), {
        ...data,
        schedule_list: data.schedule_list ?? [],
        bet_quick_amounts: data.bet_quick_amounts ?? DEFAULT_QUICK_AMOUNTS,
      })
      // 非首次拉取：保留用户当前选中的日期与场次（切换 tab / 切换场次 / 下注刷新）
      if (!isFirstLoad) {
        state.selected_date = selected_date
        state.selected_match_id = selected_match_id
      }
      state.baseDataLoaded = true
    })
  },
})

export default WorldCupGuessSlice.reducer
export const WorldCupGuessActions = WorldCupGuessSlice.actions
